import { ZoomConfig } from "./zoomConfig";
import { RefObject } from "react";

const windowWidth = ZoomConfig.windowWidth;
const windowHeight = ZoomConfig.windowHeight;
const zoomScale = ZoomConfig.zoomMaxScale;
const modelImageSize = ZoomConfig.modelImageSize;

export function calculateCoordinates(bbox: number[], image: RefObject<HTMLImageElement>) {
  const { naturalWidth, naturalHeight, clientWidth, clientHeight } = image.current;

  const centerX = (bbox[0] + bbox[2]) / 2;
  const centerY = (bbox[1] + bbox[3]) / 2;

  const scaleX = (clientWidth / naturalWidth) * (naturalWidth / modelImageSize) * zoomScale;
  const scaleY = (clientHeight / naturalHeight) * (naturalHeight / modelImageSize) * zoomScale;

  return [windowWidth / 2 - centerX * scaleX, windowHeight / 2 - centerY * scaleY];
}
